import * as THREE from "three";
import { cloud, three, data, rt, audio } from "xx-packages";
const { cloudClient, typeManager } = cloud;
const halfPi = Math.PI / 2;
const { Ctrl, EasingValue, inputManager } = window;

// const halfPi = Math.PI / 2;
// const { Ctrl, EasingValue, inputManager } = window;

// class Panorama extends Ctrl {
// 	constructor(camera, targetObj) {
// 		super(camera, targetObj);

// 		// Touch/finger input properties.
// 		this.lookMultiplier = 1.2;
// 		this._rotX = new EasingValue(0, 0, 8, 0.0005);
// 		this._rotY = new EasingValue(0, 0, 8, 0.0005);
//       	this._targetRotY = targetObj?.rotation?.y || 0;
// 		this.dirY = -1;
// 		this.dirX = -1;
// 		this._camRotX = 0;
// 		this._camRotY = 0;

// 		// Flag to determine whether to use touch input.
// 		this.doTouch = false // true; // or set this externally as needed

// 		// === Device Orientation Properties ===
// 		// (Do not reference this._camera here; see start() below.)
// 		this.enabled = true;
// 		this.deviceOrientation = {};
// 		this.screenOrientation = 0;
// 		this.alphaOffset = 0; // in radians

// 		// To track changes in orientation.
// 		this._lastQuaternion = new THREE.Quaternion();

// 		// A temporary quaternion to store the base device orientation.
// 		this._baseQuaternion = new THREE.Quaternion();

// 		// Bind event handlers.
// 		this._onDeviceOrientationChangeEvent = this._onDeviceOrientationChangeEvent.bind(this);
// 		this._onScreenOrientationChangeEvent = this._onScreenOrientationChangeEvent.bind(this);

//       console.log( this )
// 	}

// 	// This method is called once the instance is fully set up.
// 	start() {
// 		// Trigger the device orientation permission on user interaction.
// 		window.addEventListener('click', _ => this._connect(), { once: true });
// 		// No need to reorder the camera's internal rotation here.
//       this.scrollSpeed = this.params.scrollSpeed || 1
// 		if (!this.params.invert) return;
// 		console.warn("Panorama started", this);
// 	}

// 	// Sets up event listeners for device orientation.
// 	_connect() {
// 		this._onScreenOrientationChangeEvent(); // initialize screen orientation

// 		// iOS 13+ requires permission.
// 		if (
// 			window.DeviceOrientationEvent !== undefined &&
// 			typeof window.DeviceOrientationEvent.requestPermission === 'function'
// 		) {
// 			window.DeviceOrientationEvent.requestPermission().then((response) => {
// 				if (response === 'granted') {
// 					window.addEventListener('orientationchange', this._onScreenOrientationChangeEvent, false);
// 					window.addEventListener('deviceorientation', this._onDeviceOrientationChangeEvent, false);
// 				}
// 			}).catch((error) => {
// 				console.error('Panorama: Unable to use DeviceOrientation API:', error);
// 			});
// 		} else {
// 			window.addEventListener('orientationchange', this._onScreenOrientationChangeEvent, false);
// 			window.addEventListener('deviceorientation', this._onDeviceOrientationChangeEvent, false);
// 		}
// 		this.enabled = true;
// 	}

// 	_disconnect() {
// 		window.removeEventListener('orientationchange', this._onScreenOrientationChangeEvent, false);
// 		window.removeEventListener('deviceorientation', this._onDeviceOrientationChangeEvent, false);
// 		this.enabled = false;
// 	}

// 	_onDeviceOrientationChangeEvent(event) {
// 		this.deviceOrientation = event;
// 	}

// 	_onScreenOrientationChangeEvent() {
// 		this.screenOrientation = window.orientation || 0;
// 	}

// 	// Computes the base device orientation quaternion using a temporary Euler.
// 	_setObjectQuaternion(quaternion, alpha, beta, gamma, orient) {
// 		const zee = new THREE.Vector3(0, 0, 1);
// 		const euler = new THREE.Euler();
// 		const q0 = new THREE.Quaternion();
// 		// Rotate -PI/2 around the x-axis.
// 		const q1 = new THREE.Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));

// 		// Set Euler angles in 'YXZ' order.
// 		euler.set(beta, alpha, -gamma, 'YXZ');
// 		quaternion.setFromEuler(euler);
// 		quaternion.multiply(q1); // Adjust so camera looks out the back of the device.
// 		quaternion.multiply(q0.setFromAxisAngle(zee, -orient)); // Compensate for screen orientation.
// 	}

// 	_updateDeviceOrientation() {
// 		if (!this.enabled) return;
// 		if (!this.deviceOrientation) return;

// 		const EPS = 0.000001;
// 		const device = this.deviceOrientation;
// 		// Convert device angles (degrees to radians).
// 		const alpha = device.alpha ? THREE.MathUtils.degToRad(device.alpha) + this.alphaOffset : 0;
// 		const beta  = device.beta  ? THREE.MathUtils.degToRad(device.beta)  : 0;
// 		const gamma = device.gamma ? THREE.MathUtils.degToRad(device.gamma) : 0;
// 		const orient = this.screenOrientation ? THREE.MathUtils.degToRad(this.screenOrientation) : 0;

// 		// Compute the base quaternion from device orientation.
// 		this._setObjectQuaternion(this._baseQuaternion, alpha, beta, gamma, orient);

// 		// Optionally compare with the last quaternion to detect changes.
// 		if (8 * (1 - this._lastQuaternion.dot(this._baseQuaternion)) > EPS) {
// 			this._lastQuaternion.copy(this._baseQuaternion);
// 			// Dispatch an event here if needed.
// 		}
// 	}

// 	update() {
// 		if (!this._active) return;

// 		// 1. Update the base device orientation.
// 		this._updateDeviceOrientation();

// 		let finalQuaternion;
// 		if (this.doTouch) {
// 			// 2. Update finger input offsets.
// 			if (this.params.invert && this.params.invert.sideways) {
// 				const min = this.params.invert.sideways.minWidth;
// 				const max = this.params.invert.sideways.maxWidth;
// 				this.dirY = (window.innerWidth > min && window.innerWidth < max) ? -1 : 1;
// 			}

// 			// Update accumulated input angles.
// 			this._camRotX = THREE.MathUtils.clamp(
// 				this._camRotX + inputManager.lookY * this.lookMultiplier,
// 				-halfPi,
// 				halfPi
// 			);
// 			if (this.params.angleX_min !== undefined) {
// 				this._camRotX = THREE.MathUtils.clamp(
// 					this._camRotX,
// 					this.params.angleX_min * Math.PI / 180,
// 					this.params.angleX_max * Math.PI / 180
// 				);
// 			}
// 			this._camRotY += inputManager.lookX * this.lookMultiplier * this.dirY;

// 			this._rotX.set(this._camRotX);
// 			this._rotY.set(this._camRotY);

// 			// 3. Compute the input offset as rotations around fixed world axes.
// 			// Use the world Y axis for horizontal (yaw) and world X axis for vertical (pitch).
// 			const qYaw = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), this._camRotY);
// 			const qPitch = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), this._camRotX);

// 			// Combine the two rotations. Order matters.
// 			const offsetQuaternion = new THREE.Quaternion();
// 			offsetQuaternion.multiplyQuaternions(qPitch, qYaw);

// 			// 4. Apply the world-space offset to the device's base orientation.
// 			// Pre-multiplication ensures the input rotation happens in world space.
// 			finalQuaternion = offsetQuaternion.multiply(this._baseQuaternion.clone());
// 		} else {
// 			// If doTouch is false, only use the device orientation.
// 			finalQuaternion = this._baseQuaternion.clone();
// 		}

// 		this._camera.quaternion.copy(finalQuaternion);

//       this._targetRotY = this._targetRotY - inputManager.lookX * this.lookMultiplier;
//       this._rotY.set(this._targetRotY);
//       this._targetObj.rotation.set(0, this.scrollSpeed * this._rotY.get(), 0, 'XYZ');
// 	}

// 	setActive(active) {
// 		if (this._active === active) return;
// 		this._active = active;
// 		if (this._active) {
// 			const { x, y, z } = this._targetObj.position;
// 			this._camera.position.set(x, y, z);
// 		}
// 	}

// 	dispose() {
// 		this._disconnect();
// 	}
// }


export default class Panorama extends Ctrl {
  constructor(camera, targetObj) {
    super(camera, targetObj);

    // Touch/finger input properties.
    this.lookMultiplier = 1.2;
    this._rotX = new EasingValue(0, 0, 8, 0.0005);
    this._rotY = new EasingValue(0, 0, 8, 0.0005);
    this._targetRotY = targetObj?.rotation?.y || 0;
    this.dirY = -1;
    this.dirX = -1;
    this._camRotX = 0;
    this._camRotY = 0;

    // Flag to determine whether to use touch input.
    this.doTouch = false; // true; // or set this externally as needed

    // === Device Orientation Properties ===
    // (Do not reference this._camera here; see start() below.)
    this.enabled = true;
    this.deviceOrientation = {};
    this.screenOrientation = 0;
    this.alphaOffset = 0; // in radians

    // To track changes in orientation.
    this._lastQuaternion = new THREE.Quaternion();

    // A temporary quaternion to store the base device orientation.
    this._baseQuaternion = new THREE.Quaternion(0, 0, 0, 1);

    // Bind event handlers.
    this._onDeviceOrientationChangeEvent =
      this._onDeviceOrientationChangeEvent.bind(this);
    this._onScreenOrientationChangeEvent =
      this._onScreenOrientationChangeEvent.bind(this);

    console.log(this);
  }

  // This method is called once the instance is fully set up.
  start() {
    // Trigger the device orientation permission on user interaction.
    window.addEventListener("click", (_) => this._connect(), { once: true });
    // No need to reorder the camera's internal rotation here.
    this.scrollSpeed = this.params.scrollSpeed || 1;
    if (!this.params.invert) return;
    console.warn("Panorama started", this);
  }

  // Sets up event listeners for device orientation.
  _connect() {
    this._onScreenOrientationChangeEvent(); // initialize screen orientation

    // iOS 13+ requires permission.
    if (
      window.DeviceOrientationEvent !== undefined &&
      typeof window.DeviceOrientationEvent.requestPermission === "function"
    ) {
      window.DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response === "granted") {
           
            window.addEventListener(
              "orientationchange",
              this._onScreenOrientationChangeEvent,
              false
            );
            window.addEventListener(
              "deviceorientation",
              this._onDeviceOrientationChangeEvent,
              false
            );
          }
        })
        .catch((error) => {
          console.error(
            "Panorama: Unable to use DeviceOrientation API:",
            error
          );
        });
    } else {
      window.addEventListener(
        "orientationchange",
        this._onScreenOrientationChangeEvent,
        false
      );
      window.addEventListener(
        "deviceorientation",
        this._onDeviceOrientationChangeEvent,
        false
      );
    }
    this.enabled = true;
  }

  _disconnect() {
    window.removeEventListener(
      "orientationchange",
      this._onScreenOrientationChangeEvent,
      false
    );
    window.removeEventListener(
      "deviceorientation",
      this._onDeviceOrientationChangeEvent,
      false
    );
    this.enabled = false;
  }

  _onDeviceOrientationChangeEvent(event) {
    this.deviceOrientation = event;

  }

  _onScreenOrientationChangeEvent() {
    this.screenOrientation = window.orientation || 0;
  }

  // Computes the base device orientation quaternion using a temporary Euler.
  _setObjectQuaternion(quaternion, alpha, beta, gamma, orient) {
    const zee = new THREE.Vector3(0, 0, 1);
    const euler = new THREE.Euler();
    const q0 = new THREE.Quaternion();
    // Rotate -PI/2 around the x-axis.
    const q1 = new THREE.Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));

    // Set Euler angles in 'YXZ' order.
    euler.set(beta, alpha, -gamma, "YXZ");
    quaternion.setFromEuler(euler);
    quaternion.multiply(q1); // Adjust so camera looks out the back of the device.
    quaternion.multiply(q0.setFromAxisAngle(zee, -orient)); // Compensate for screen orientation.
  }

  _updateDeviceOrientation() {
    if (!this.enabled) return;
    if (!this.deviceOrientation || !Object.keys(this.deviceOrientation).length)
      return;
    if (this.deviceOrientation.alpha === null) return;
    if (this.deviceOrientation.beta === null) return;
    if (this.deviceOrientation.gamma === null) return;
    console.log( this.deviceOrientation.alpha.toFixed( 2) , this.deviceOrientation.beta.toFixed( 2) ,
                this.deviceOrientation.gamma.toFixed( 2) )

   
    const EPS = 0.000001;
    const device = this.deviceOrientation;
    // Convert device angles (degrees to radians).
    const alpha = device.alpha
      ? THREE.MathUtils.degToRad(device.alpha) + this.alphaOffset
      : 0;
    const beta = device.beta ? THREE.MathUtils.degToRad(device.beta) : 0;
    const gamma = device.gamma ? THREE.MathUtils.degToRad(device.gamma) : 0;
    const orient = this.screenOrientation
      ? THREE.MathUtils.degToRad(this.screenOrientation)
      : 0;

    // Compute the base quaternion from device orientation.
    this._setObjectQuaternion(this._baseQuaternion, alpha, beta, gamma, orient);

    // Optionally compare with the last quaternion to detect changes.
    if (8 * (1 - this._lastQuaternion.dot(this._baseQuaternion)) > EPS) {
      this._lastQuaternion.copy(this._baseQuaternion);
      // Dispatch an event here if needed.
    }
  }

  update() {
    if (!this._active) return;

    // 1. Update the base device orientation.
    this._updateDeviceOrientation();

    let finalQuaternion;
    if (this.doTouch) {
      // 2. Update finger input offsets.
      if (this.params.invert && this.params.invert.sideways) {
        const min = this.params.invert.sideways.minWidth;
        const max = this.params.invert.sideways.maxWidth;
        this.dirY = window.innerWidth > min && window.innerWidth < max ? -1 : 1;
      }

      // Update accumulated input angles.
      this._camRotX = THREE.MathUtils.clamp(
        this._camRotX + inputManager.lookY * this.lookMultiplier,
        -halfPi,
        halfPi
      );
      if (this.params.angleX_min !== undefined) {
        this._camRotX = THREE.MathUtils.clamp(
          this._camRotX,
          (this.params.angleX_min * Math.PI) / 180,
          (this.params.angleX_max * Math.PI) / 180
        );
      }
      this._camRotY += inputManager.lookX * this.lookMultiplier * this.dirY;

      this._rotX.set(this._camRotX);
      this._rotY.set(this._camRotY);

      // 3. Compute the input offset as rotations around fixed world axes.
      // Use the world Y axis for horizontal (yaw) and world X axis for vertical (pitch).
      const qYaw = new THREE.Quaternion().setFromAxisAngle(
        new THREE.Vector3(0, 1, 0),
        this._camRotY
      );
      const qPitch = new THREE.Quaternion().setFromAxisAngle(
        new THREE.Vector3(1, 0, 0),
        this._camRotX
      );

      // Combine the two rotations. Order matters.
      const offsetQuaternion = new THREE.Quaternion();
      offsetQuaternion.multiplyQuaternions(qPitch, qYaw);

      // 4. Apply the world-space offset to the device's base orientation.
      // Pre-multiplication ensures the input rotation happens in world space.
      finalQuaternion = offsetQuaternion.multiply(this._baseQuaternion.clone());
    } else {
      // If doTouch is false, only use the device orientation.
      finalQuaternion = this._baseQuaternion.clone();
    }

    this._camera.quaternion.copy(finalQuaternion);

    this._targetRotY =
      this._targetRotY - inputManager.lookX * this.lookMultiplier;
    this._rotY.set(this._targetRotY);
    this._targetObj.rotation.set(
      0,
      this.scrollSpeed * this._rotY.get(),
      0,
      "XYZ"
    );
  }

  setActive(active) {
    if (this._active === active) return;
    this._active = active;
    if (this._active) {
      const { x, y, z } = this._targetObj.position;
      this._camera.position.set(x, y, z);
    }
  }

  dispose() {
    this._disconnect();
  }
}


typeManager.registerClass("67c829659064dc7c8419ee07", Panorama);
